import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionLoaderService {

  constructor() { }

  private permissionApiCallState: Subject<boolean> = new Subject<boolean>();

  setState(state: boolean) {
    this.permissionApiCallState.next(state);
  }

  getState(): Observable<boolean> {
    return this.permissionApiCallState.asObservable();
  }
}
